import React, { useState } from 'react';
import { motion } from 'framer-motion';

const sizes = ['7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '12', '13'];

const ProductCard = ({ product, index }) => {
  const [selectedSize, setSelectedSize] = useState(null);

  return (
    <motion.div 
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.2 }}
      className="flex flex-col lg:flex-row bg-[#111] border border-[#333] group"
    >
      <div className="w-full lg:w-1/2 relative overflow-hidden bg-black p-8 flex items-center justify-center min-h-[400px]">
        <div className="absolute top-4 left-4 bg-acid text-black text-xs font-bold px-2 py-1 z-10 uppercase">
          {product.badge}
        </div>
        <img 
          src={product.image} 
          alt={product.name} 
          className="w-full max-w-md h-auto object-contain transform group-hover:scale-105 transition-transform duration-700 grayscale group-hover:grayscale-0"
        />
      </div>

      <div className="w-full lg:w-1/2 p-6 sm:p-10 flex flex-col justify-between">
        <div>
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-3xl sm:text-4xl font-black uppercase leading-none">{product.name}</h2>
            <span className="text-2xl font-mono text-acid">${product.price}</span>
          </div>
          <p className="text-[#737373] text-sm uppercase font-bold tracking-wide mb-8">
            {product.description}
          </p>

          <div className="mb-8">
            <div className="flex justify-between items-end mb-4">
              <span className="text-sm font-bold tracking-widest uppercase">Select Size (US)</span>
              <span className="text-xs text-[#737373] cursor-pointer hover:text-white">Size Guide</span>
            </div>
            <div className="grid grid-cols-4 sm:grid-cols-6 gap-2">
              {sizes.map((size) => (
                <button
                  key={size}
                  onClick={() => setSelectedSize(size)}
                  className={`py-3 text-sm font-bold transition-all border ${
                    selectedSize === size 
                      ? 'bg-acid border-acid text-black' 
                      : 'border-[#333] text-[#737373] hover:border-white hover:text-white'
                  }`}
                >
                  {size}
                </button>
              ))}
            </div>
          </div>
        </div>

        <button 
          className={`w-full py-5 text-xl font-black uppercase tracking-tight transition-all ${
            selectedSize 
              ? 'bg-acid text-black hover:bg-white' 
              : 'bg-[#222] text-[#555] cursor-not-allowed'
          }`}
          disabled={!selectedSize}
        >
          {selectedSize ? `Add to Cart - ${product.price}` : 'Select Size'}
        </button>
      </div>
    </motion.div>
  );
};

export default ProductCard;